export const isSponsoredCheck = (
  productIsSponsored?: boolean,
  productIsInternallyPromoted?: boolean,
) => {
  if (productIsSponsored) {
    return 'true'
  }

  if (productIsInternallyPromoted) {
    return 'internal'
  }

  return 'false'
}

type CurrencyCode = 'AUD' | 'GBP' | 'EUR' | 'USD'

export const currencyCode = (currencyCodeString: string): CurrencyCode => {
  const supportedCurrencyCodes = ['AUD', 'GBP', 'EUR', 'USD']

  if (supportedCurrencyCodes.includes(currencyCodeString)) {
    return currencyCodeString as CurrencyCode
  }
  return 'GBP'
}

type DynamicImages = {
  intentKey: string
  large: {
    webp: { url: string; title: string }[]
  }
  medium: {
    webp: { url: string; title: string }[]
  }
}

export const createDynamicContent = (
  dynamicImages?: DynamicImages | null,
): string => {
  const hasImages =
    dynamicImages?.medium?.webp?.length || dynamicImages?.large?.webp?.length

  if (dynamicImages?.intentKey && hasImages) {
    return `true | ${dynamicImages.intentKey.toLowerCase()}`
  }
  return 'false'
}
